import React from 'react';
import { TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { useConfig } from 'common/providers/configProvider';
import { CookieSetOptions } from 'universal-cookie';
import { useRestaurants } from '../providers/restaurantsProvider';
import { useContent } from '../../content/content-provider';

// Temporary type for Restaurant. Type should be inferred by useRestaurants hook.
interface Restaurant {
  restaurantId: string;
  address: {
    line1: string;
    city: string;
    postalCode?: string;
  };
  name: string;
  shortName: string;
  coordinates: {
    latitude: number;
    longitude: number;
  };
}

type RestaurantSelectProps = {
  restaurantCookie: string;
  removeRestaurantCookie: (name: 'restaurantCookie', options?: CookieSetOptions) => void;
  removeIdCookie: (name: 'idCookie', options?: CookieSetOptions) => void;
};

const RestaurantSelect = ({
  restaurantCookie,
  removeRestaurantCookie,
  removeIdCookie,
}: RestaurantSelectProps) => {
  const [content] = useContent();

  const {
    results,
    areResultsVisible,
    dispatch: { selectRestaurant, showResults, hideResults },
  } = useRestaurants();

  const { paymentMode } = useConfig();

  const storedRestaurant = paymentMode && restaurantCookie;

  const handleOnChange = (event, value) => {
    selectRestaurant(event, value);
    if (!value) {
      removeRestaurantCookie('restaurantCookie');
      removeIdCookie('idCookie');
    }
  };

  const selectedRestaurant = storedRestaurant || selectRestaurant.shortName;

  return (
    <Autocomplete<Restaurant>
      popupIcon={<KeyboardArrowDownIcon />}
      open={areResultsVisible}
      onOpen={showResults}
      onClose={hideResults}
      onChange={handleOnChange}
      id="restaurants"
      fullWidth
      data-testid="restaurants"
      data-cy="restaurant-select"
      openOnFocus
      options={results}
      renderOption={({ shortName }) => shortName}
      getOptionLabel={({ shortName }) => storedRestaurant || shortName}
      value={selectedRestaurant}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={content.restaurants.newPlaceholder}
          variant="standard"
          InputLabelProps={{
            shrink: false,
          }}
        />
      )}
    />
  );
};

export default RestaurantSelect;
